import React, { useMemo } from 'react';

import { Switch, useLocation } from 'react-router-dom';

import Footer from 'components/Footer';
import LoadingContainer from 'components/LoadingContainer';
import Navbar from 'components/Navbar';
import { useUserInfo } from 'hooks/userinfo';
import About from 'pages/About';
import AddService from 'pages/AddService';
import EditReviews from 'pages/EditReviews';
import EditService from 'pages/EditService';
import Home from 'pages/Home';
import NotFound from 'pages/NotFound';
import Profile from 'pages/Profile';
import ServiceDetails from 'pages/ServiceDetails';
import SignIn from 'pages/SignIn';
import Terms from 'pages/Terms';

import Route from './Route';
import { Container, FooterPush } from './styles';

const Routes: React.FC = () => {
  const location = useLocation();
  const { userInfoLoading } = useUserInfo();

  const currentRoute = useMemo(() => {
    const currentUrl = location.pathname;
    return currentUrl.substring(currentUrl.lastIndexOf('/') + 1);
  }, [location.pathname]);

  return (
    <Container>
      {currentRoute !== 'signin' && <Navbar />}
      {userInfoLoading ? (
        <LoadingContainer />
      ) : (
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/signin" component={SignIn} isLogin />
          <Route path="/about" component={About} />
          <Route path="/terms" component={Terms} />
          <Route path="/services/:serviceid" exact component={ServiceDetails} />
          <Route
            path="/services/:serviceid/edit/reviews"
            component={EditReviews}
          />
          <Route path="/services/:serviceid/edit" component={EditService} />
          <Route path="/addservice" component={AddService} />
          <Route path="/services/:serviceid" component={ServiceDetails} />
          <Route path="/profile/:profileid" component={Profile} />
          <Route component={NotFound} />
        </Switch>
      )}
      {currentRoute !== 'signin' && <FooterPush />}
      {currentRoute !== 'signin' && <Footer />}
    </Container>
  );
};
export default Routes;
